import { RootState } from '../../../reducers'
import { currentBotConfigurationSelector } from './currentBotConfigurationSelector'

export function isBotSoftDeletedSelector(state: RootState): boolean {
  return !!currentBotConfigurationSelector(state)?.softDeletedAtTimestamp
}
